const PERCENTAGE_TO_CONSIDER_LISTENED = 0.95;

// Number of seconds a bucket represents for stats
const PODCAST_EPISODE_STATS_BUCKET_LISTENING_SIZE = 5;

export function isConsideredListened(position: number, duration: number) {
  return position / duration >= PERCENTAGE_TO_CONSIDER_LISTENED;
}

export function podcastUtil() {
  return {
    getStatsBucketNumber,
    PODCAST_EPISODE_STATS_BUCKET_LISTENING_SIZE,
  };
}

function getStatsBucketNumber(time: number) {
  return Math.floor(time / PODCAST_EPISODE_STATS_BUCKET_LISTENING_SIZE);
}
